import { useInfiniteQuery } from '@tanstack/react-query';

import { getMfAutoOrder } from '@services/api/platform/mfAutoOrder';
import { useCallback, useEffect } from 'react';

function useMfAutoOrder() {
  const { cb, key } = getMfAutoOrder();

  const { data, fetchNextPage, isInitialLoading, isFetchingNextPage, hasNextPage, refetch } =
    useInfiniteQuery(key, cb, {
      getNextPageParam: (lastPage, allPages) => lastPage?.result?.next && allPages.length,
      select: (datas) => datas.pages?.flatMap((page) => page?.results),
    });

  useEffect(() => {
    window.testFetchNext = fetchNextPage;
  }, [fetchNextPage]);

  const fetchNext = useCallback(() => {
    if (!isFetchingNextPage && hasNextPage) {
      fetchNextPage();
    }
  }, [fetchNextPage, isFetchingNextPage, hasNextPage]);

  return { data: data || [], isInitialLoading, fetchNextPage: fetchNext, refetch };
}

export default useMfAutoOrder;
